module.exports = __webpack_public_path__ + "static/Veneers 2 intraoral after-e054e116a8b9956924bb3f539250fbca.jpg";